export default function mapPriorityNameToCode(name: string) {
  switch (name) {
    case 'Low':
      return 'LO';
    case 'Standard':
      return 'ST';
    case 'Rush':
      return 'RU';
    case 'Critical':
      return 'CR';
    default:
      return ''; 
  }
}
